import gql from 'graphql-tag';

const ADD_TICKET_VIEW = gql`
  mutation(
    $name: String
    $viewCondition: RuleConditionInput
    $shared: Boolean!
    $addEntityShare: AddEntityShareInput
  ) {
    addTicketView(
      input: {
        name: $name
        viewCondition: $viewCondition
        shared: $shared
        addEntityShare: $addEntityShare
      }
    ) {
      id
      name
      viewCondition
      shared
      entityShare {
        id
        userShareType
        groupShareType
        users {
          userId
          email
        }
        groups {
          groupId
          name
        }
      }
    }
  }
`;

const UPDATE_TICKET_VIEW = gql`
  mutation(
    $id: ID!
    $name: String!
    $viewCondition: RuleConditionInput
    $shared: Boolean!
    $addEntityShare: AddEntityShareInput
    $updateEntityShare: UpdateEntityShareInput
    $deleteEntityShare: IdentifierInput
  ) {
    updateTicketView(
      id: $id
      input: {
        name: $name
        viewCondition: $viewCondition
        shared: $shared
        addEntityShare: $addEntityShare
        updateEntityShare: $updateEntityShare
        deleteEntityShare: $deleteEntityShare
      }
    ) {
      id
      name
      shared
      entityShare {
        id
        userShareType
        groupShareType
        users {
          userId
          email
        }
        groups {
          groupId
          name
        }
      }
    }
  }
`;

const GET_TICKETVIEWS = gql`
  query {
    getTicketViews {
      id
      name
      shared
      viewCondition
      customView
      systemViewProperty
      entityShare {
        id
        userShareType
        groupShareType
        users {
          userId
          email
          name
        }
        groups {
          groupId
          name
        }
      }
    }
  }
`;

const GET_TASKVIEWS = gql`
  query {
    getTaskViews {
      id
      name
      shared
      viewCondition
      customView
    }
  }
`;

const GET_TASK_LISTVIEW_META = gql`
  query {
    getTaskListViewMetaInfo
  }
`;

const GET_TICKETVIEW = gql`
  query getTicket($id: ID!) {
    getTicketView(id: $id) {
      id
      name
      viewCondition
      customView
      shared
      entityShare {
        id
        userShareType
        groupShareType
        users {
          userId
          email
          name
        }
        groups {
          groupId
          name
        }
      }
    }
  }
`;
const DELETE_TICKET_VIEW = gql`
  mutation($id: ID!) {
    deleteTicketView(id: $id)
  }
`;

export {
  ADD_TICKET_VIEW,
  GET_TICKETVIEWS,
  GET_TASKVIEWS,
  GET_TICKETVIEW,
  GET_TASK_LISTVIEW_META,
  UPDATE_TICKET_VIEW,
  DELETE_TICKET_VIEW
};
